// axiosInstance.js
import axios from "axios";
import baseUrl from "services/constants";
import { generateToken } from "./authentication";
import { clearAuthStorage } from "app/utils/authUtils";

const isPublicRoute = (config) => {
  return config.headers?.["x-skip-auth"] === "true";
};

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_API_KEY,
  },
});

const redirectToLogin = () => {
  const publicUser = localStorage.getItem("isPublicAccess");
  const isLoggedIn = localStorage.getItem("logIn") === "true";
  const hasAccessToken = localStorage.getItem("access_token");

  const currentUrl = window.location.pathname;
  const matchRequestConfirmation = currentUrl.match(
    /^\/request-confirmation\/([^/]+)\/([^/]+)\/([^/]+)$/,
  );
  const matchPayment = currentUrl.match(/^\/payment\/[^/]+(?:\/[^/]+)?$/);
  const matchEventPage = currentUrl.match(/^\/([^/]+)$/);
  const isEventsPage = currentUrl === "/events";
  const isAuthenticated = isLoggedIn || hasAccessToken;

  if (!isAuthenticated && isEventsPage && publicUser === "true") {
    return;
  }

  if (!isAuthenticated && matchEventPage) {
    return;
  }

  if (
    !isAuthenticated &&
    !matchRequestConfirmation &&
    !matchPayment &&
    !isEventsPage
  ) {
    window.location.href = "/";
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  } else if (!isAuthenticated && matchRequestConfirmation) {
    const [_, id, requestId, action] = matchRequestConfirmation;
    window.location.href = `/request-confirmation/${id}/${requestId}/${action}`;
    return;
  }
};

axiosInstance.interceptors.request.use((config) => {
  if (isPublicRoute(config)) {
    return config;
  }
  const accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (isPublicRoute(originalRequest)) {
      console.error("Skipping auth error for public route", error);
      return Promise.reject(error);
    }

    if (error.code === "ERR_NETWORK") {
      alert("Network issue. Please try again later.");
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refresh_token");

      try {
        const res = await generateToken({ refresh_token: refreshToken });
        if (res?.data?.data?.access_token) {
          originalRequest.headers.Authorization = `Bearer ${res.data.data.access_token}`;
          return axiosInstance(originalRequest);
        } else {
          clearAuthStorage();
          redirectToLogin();
          return Promise.reject(error);
        }
      } catch (refreshError) {
        clearAuthStorage();
        redirectToLogin();
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
